<div class="w-full">
  <header *ngIf="showSidebar">
    <!-- FULL SIDEBAR -->
    <large-sidebar
      *ngIf="sidebarStatus === 'large'"
      [sidebarStatus]="sidebarStatus"
      (sidebarStatusChange)="toggleSidebarStatus($event)"
    ></large-sidebar>

    <!-- SMALL SIDEBAR -->
    <small-sidebar
      *ngIf="sidebarStatus === 'small'"
      [sidebarStatus]="sidebarStatus"
      (sidebarStatusChange)="toggleSidebarStatus($event)"
    ></small-sidebar>
  </header>

  <div
    [ngClass]="{
      'ml-[355px] duration-150': sidebarStatus === 'large' && currentPlan === 'al',
      'ml-[375px] duration-150': sidebarStatus === 'large' && currentPlan === 'ms',
      'ml-[260px] duration-150': sidebarStatus === 'large' && currentPlan === 'ga',
      'ml-[63px] duration-300': sidebarStatus === 'small'
    }"
  >
    <router-outlet />
  </div>
</div>

